(() => {
  if (window.cwsCollectionFilters) return;
  window.cwsCollectionFilters = true;

  // KK-1857: the CWS header does not set the theme --height-header variable, so sticky
  // collection controls read their own offset, measured from the pinned header.
  const initHeaderOffset = () => {
    const header = document.getElementById('sticky-header');
    if (!header) return;

    const root = document.documentElement;
    const update = () => {
      // The open phone menu grows the header to the full screen; keep the resting offset.
      if (document.body.classList.contains('cws-header-navigation-open')) return;
      root.style.setProperty('--cws-header-offset', `${Math.round(header.getBoundingClientRect().height)}px`);
    };

    update();
    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(header);
    } else {
      window.addEventListener('resize', update, { passive: true });
    }
  };

  // KK-1858: long filter lists show six values and a "Show all" button. facets.js swaps the
  // filter forms after every change, so the expanded lists are remembered and restored.
  const expandedFilters = new Set();

  const expandList = (list) => {
    list.classList.add('is-expanded');
    const button = list.nextElementSibling;
    if (button && button.matches('[data-cws-show-all]')) button.setAttribute('aria-expanded', 'true');
  };

  const initShowAll = () => {
    const grid = document.querySelector('.cws-collection-grid');
    if (!grid) return;

    grid.addEventListener('click', (event) => {
      const button = event.target.closest('[data-cws-show-all]');
      if (!button) return;
      event.preventDefault();
      const list = button.previousElementSibling;
      if (!list || !list.matches('.cws-filter-values')) return;
      expandList(list);
      if (list.dataset.cwsFilter) expandedFilters.add(list.dataset.cwsFilter);
    });

    new MutationObserver(() => {
      if (!expandedFilters.size) return;
      grid.querySelectorAll('.cws-filter-values[data-cws-filter]:not(.is-expanded)').forEach((list) => {
        if (expandedFilters.has(list.dataset.cwsFilter)) expandList(list);
      });
    }).observe(grid, { childList: true, subtree: true });
  };

  const init = () => {
    initHeaderOffset();
    initShowAll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
